import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { NotificationItem } from '../notifications-api';
import { useNotifications } from '../notifications-hooks';
import { handleReferencedEntityItem } from '../utility/notification-related-item-dispatcher';

export function NotificationRelatedItemDispatcher() {
  const navigate = useNavigate();
  const { notificationsDelegate } = useNotifications();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/require-await
    const callback = async (destination: NotificationItem): Promise<void> => {
      handleReferencedEntityItem(destination, { navigate });
    };

    if (!notificationsDelegate) {
      return;
    }

    notificationsDelegate?.onNotificationInvoked(callback);

    return () => {
      notificationsDelegate?.onNotificationInvoked(undefined);
    };
  }, [navigate, notificationsDelegate]);

  return null;
}
